/**
 * Should this keystroke submit the form?
 *
 * Extracted from `Form.jsx` so the rule is testable on its own — the same shape as
 * `Table/tableSort.js` and `Sidebar/appNavLayout.js`. `Form` binds one `onKeyDown`
 * to every control it renders, so this one predicate decides for all of them.
 *
 * Two things it refuses, both of which used to submit:
 *
 * 1. **Enter inside a `<textarea>` is a NEWLINE.** The handler is bound to
 *    textareas as well as inputs, so a multi-line field could not take a second
 *    line: the first Enter submitted the form and closed whatever dialog it sat
 *    in. Decided on the event TARGET rather than by not binding the handler to
 *    textareas, so it stays true wherever the handler is attached.
 * 2. **Shift+Enter never submits**, anywhere. It is the universal "newline, not
 *    send" chord; honouring it on single-line controls too costs nothing and
 *    surprises nobody.
 *
 * Everything else about submitting — whether an `onSubmit` exists, and whether the
 * form validates — stays in `Form.jsx`, because it needs the component's own props
 * and validation closure. This answers only the keyboard question.
 */
export function shouldSubmitOnKey(event) {
  if (!event || event.key !== "Enter") return false;
  if (event.shiftKey) return false;
  // `?.` because a synthetic event in a test, or a dispatched event with no
  // target, must not throw on the way to a plain "no".
  if (event.target?.tagName === "TEXTAREA") return false;
  return true;
}
